import { render, staticRenderFns } from "./PageFlow.vue?vue&type=template&id=46636624&"
import script from "./PageFlow.vue?vue&type=script&lang=js&"
export * from "./PageFlow.vue?vue&type=script&lang=js&"
import style0 from "./PageFlow.vue?vue&type=style&index=0&id=46636624&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports